import { NgModule } from '@angular/core';
import { ToggleCheckboxDirective } from './toggle-checkbox.directive';



@NgModule({
  declarations: [ToggleCheckboxDirective],
  exports: [
    ToggleCheckboxDirective
  ]
})
export class ToggleCheckboxModule { }
